// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__woiKt","vert":"NotFound_vert__Q0psT","title":"NotFound_title__OQ-MU","paragraph":"NotFound_paragraph__O5M50","navLink":"NotFound_navLink__+9l7M"};